/**
 * 资源中心模块：教材库列表、教材详情与学习页。
 *
 * 列表、详情与学习页均匿名可读；登录只用于记录学习进度与收藏，路由层不做拦截。
 */

import { BookOpen } from '@lucide/vue'
import type { PortalModule } from '@/shell/module-registry'

const basePath = '/resources'

export const catalogModule: PortalModule = {
  key: 'catalog',
  title: '资源中心',
  icon: BookOpen,
  basePath,
  order: 25,
  defaultPath: basePath,
  nav: [{ label: '资源中心', to: basePath }],
  routes: [
    {
      path: '',
      name: 'catalog-list',
      component: () => import('./pages/CatalogList.vue'),
    },
    {
      path: ':resourceKey',
      name: 'catalog-resource-detail',
      component: () => import('./pages/ResourceDetail.vue'),
      props: true,
    },
    {
      path: ':resourceKey/learn',
      name: 'catalog-resource-learn',
      component: () => import('./pages/ResourceLearn.vue'),
      props: true,
    },
  ],
}
